import React, { useState } from "react";
import RequestService from "../../services/request.service";

// import { useNavigate } from "react-router"
// import { Modal, Row, Form, Button, Col, InputGroup } from 'react-bootstrap'
import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';


import { toast } from 'react-toastify'




import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import moment from 'moment'


import Dialog from '../../services/Dialogs'
// import { SERVER_ } from  '../../config';
import { Button, Modal } from 'react-bootstrap'


import { SERVER_ } from  '../../config';


import AuthService from '../../features/auth/auth.service'


const mensaes_validacion_generico = 'Este campo es obligatorio'


const curp2date = (curp) => {
  var m = curp.match( /^\w{4}(\w{2})(\w{2})(\w{2})/ );
  //miFecha = new Date(año,mes,dia) 
  var anyo = parseInt(m[1],10)+1900;
  if( anyo < 1950 ) anyo += 100;
  var mes = parseInt(m[2], 10)-1;
  var dia = parseInt(m[3], 10);
  return (new Date( anyo, mes, dia ));
}

const EditarTramite = ( props ) => {


    // let navigate = useNavigate();
  const user = AuthService.getCurrentUser()

    const dialog = new Dialog();


	const { show, onHide, uuid_tramite, tramite, departamento, mesa_atencion } = props



  const REG_CURP = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
  const REG_NOMBRES = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u

let SUELDO = mesa_atencion ? yup.string().required(mensaes_validacion_generico) : yup.string().nullable(true)

const schema = yup.object().shape({

          folio: yup.string().nullable(true),


            fecha_alta_anterior: yup.string().required(mensaes_validacion_generico),
            fecha_baja_anterior: yup.string().required(mensaes_validacion_generico),
            sindo: yup.string().nullable(true),

            monto_aseguramiento: yup.string().required(mensaes_validacion_generico),
            semanas_cotizadas: yup.string().required(mensaes_validacion_generico),
            monto_rcv: yup.string(),
            sueldo_trabajador: SUELDO,









          // curp: yup.string().matches( REG_CURP , "Formato de CURP invalido").required('El CURP es un campo obligatorio'),





        })

const [ deptos, setDeptos ] = useState([{ id : 0,  uuid : "", departamento : "" }])




const [ anexo_seleccionado, setAnexoSeleccionado ] = useState<any>(0)
const [ anexos_digitales, setAnexos ] = useState<any>([ { uuid_documento : "" }])
  const cargarAnexos = async () =>{
    try{
        let reqs = await RequestService.getEndPoint('requisitos-tramimte/'+uuid_tramite)
        setAnexos( reqs.data )
    } 
    catch(e){
      toast.error('Error al cargar la lista de departamentos.')
    } 
  }




  const [ afores, setAfores ] = useState<any>([])
    const cargarAfores = async () =>{
      try{
          let reqs = await RequestService.getEndPoint('afores')
          setAfores( reqs.data )
      } 
      catch(e){
        toast.error('Error al cargar la lista de afores.')
      }
  }

  React.useEffect(() => {
    cargarAfores()
    cargarAnexos()
    // formik.setFieldValue("nombres", "heh he hhehehee")
  }, []);




  const agregarAnexo = async () => {
      try{
          if(await dialog.confirm('¿Estás seguro de enviar a agregar este anexo?',{})){
              await RequestService.update('agregar-anexo-tramite/'+uuid_tramite,{ documento : anexo_enviar, uuid_requisito : anexos_digitales[anexo_seleccionado].uuid_requisito })
              setAnexoEnviar('')
              cargarAnexos()
              toast.success('Se agrego correctamente')
              // cargarMiReporte(fecha)
          }
      } 
      catch(e){
        toast.error('Error al agregar el anexo digital.')
      }
  }


  const eliminarAnexo = async (uuid_documento) => {
      try{
          if(await dialog.confirm('¿Estás seguro de eliminar este anexo?',{})){
              await RequestService.delete('eliminar-anexo-tramite/'+uuid_documento)
              setAnexoEnviar('')
              cargarAnexos()
              toast.warning('Se elimino correctamente')
              // cargarMiReporte(fecha)
          }
      } 
      catch(e){
        toast.error('Error al agregar el anexo digital.')
      }
  }


  const [ anexo_enviar, setAnexoEnviar ] = useState<any>('')

  const handleFile = e => {
    if(e.target.files.length>0){
      var files = e.target.files
        const reader = new FileReader()
            reader.onloadend = () => {
              if(reader.result){
              setAnexoEnviar( reader.result )
            }
        }
        reader.readAsDataURL(files[0])
    }
  };




	return (
		<>
      <Modal show={show} size="lg" backdrop="static" onHide={onHide} animation={true}>

        <Modal.Header closeButton>
          <Modal.Title>
          	<small>Verificación del Trámite</small>
          </Modal.Title>
        </Modal.Header>


        <Modal.Body>


          <div className="row">

            <div className="col">
                      

                    
                    <h5>Departamento</h5>
                    <p>{departamento.departamento}</p>

                    {
                      // JSON.stringify(departamento)
                    }




                    <Formik
                      enableReinitialize={true}
                      validationSchema={schema}
                      onSubmit={ async (values : any, { setSubmitting }) => {
                        try{

                          if( await dialog.confirm( '¿Estás seguro?', {} ) ){

                              // console.log('GUARDAR CAMBIOS???')
                              // console.table(values);
                              // var data_ciudadano = {
                              //   email : values.email,
                              //   celular : values.celular,
                              //   telefono : values.telefono,
                              //   direccion : values.direccion,
                              //   colonia : values.colonia,
                              //   cp : values.cp,
                              // }
                              var data_tramite : any = {
                                fecha_baja_anterior : values.fecha_baja_anterior,
                                fecha_alta_anterior : values.fecha_alta_anterior,
                                sindo : null,
                                traspaso_afore : values.traspaso_afore,
                                idafore : values.idafore,
                                idafore_anterior : values.idafore_anterior,
                                semanas_cotizadas : values.semanas_cotizadas,
                                // sueldo_trabajador : 0,
                                monto_rcv : values.monto_rcv,
                                monto_aseguramiento : values.monto_aseguramiento,
                                // anticipo : values.anticipo,
                                // folio : values.folio, 
                              }
                              // console.log('mesa_atencion',mesa_atencion)
                              if(mesa_atencion){
                                 data_tramite.sueldo_trabajador = values.sueldo_trabajador
                              }
                              if(values.sindo){
                                data_tramite.sindo = values.sindo
                              }
                              await RequestService.update('data-tramimte/'+uuid_tramite ,{ folio : values.folio, tramite_data : data_tramite })
                              toast.success('Los cambios fueron guardados correctamente')
                              onHide()
                          }


                        }
                        catch(e){
                          console.log(e)
                           toast.error('Problemas al intentar guardar los cambios');  
                         }

                      }}
                      initialValues={
                        { 
                          ...tramite,
                          fecha_baja_anterior : JSON.stringify(tramite.fecha_baja_anterior) === 'null' ? new Date() : new Date(),
                          fecha_alta_anterior : JSON.stringify(tramite.fecha_alta_anterior) === 'null' ? new Date() : new Date(),
                        }
                      }
                    >
                      {({
                        handleSubmit,
                        handleChange,
                        setFieldValue,

                        values,
                        touched,
                        isValid,
                        errors,
                      }) => (

                        <Form noValidate onSubmit={handleSubmit}>



                              <div className="row">

                                  <div className="col">

                                  {
                                    // JSON.stringify(tramite)
                                  }

                                  {
                                    // JSON.stringify(typeof tramite.fecha_alta_anterior)
                                  }

                                  {
                                    // (tramite.fecha_baja_anterior === null || tramite.fecha_baja_anterior === '' || tramite.fecha_baja_anterior === undefined) ? 'SI' : 'NO'
                                    // JSON.stringify(tramite.fecha_baja_anterior) === 'null' ? 'SI.. ' : 'NOxxxx'
                                  }

                                  
                                      <>

                                              <h4>Información del Solicitante</h4>



                                              <div className="row mb-3">
                                                  <div className="col-sm-4">
                                                    <small><b>Nombre(s)</b></small>
                                                    <p className="nm">{tramite.nombres}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                    <small><b>Apellido Paterno</b></small>
                                                    <p className="nm">{tramite.paterno}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                    <small><b>Apellido Materno</b></small>
                                                    <p className="nm">{tramite.materno}</p>
                                                  </div>
                                              </div>

                                              <div className="row mb-3">
                                                  <div className="col-sm-4">
                                                    <small><b>C.U.R.P.</b></small>
                                                    <p className="nm">{tramite.curp}</p>
                                                  </div>
                                                  <div className="col-sm-3">
                                                    <small><b>N.S.S.</b></small>
                                                    <p className="nm">{tramite.seguro_social||'No proporcionado'}</p>
                                                  </div>
                                                  <div className="col-sm-2">
                                                    <small><b>Sexo</b></small>
                                                    <p className="nm">{tramite.sexo=='M'?'MUJER':'HOMBRE'}</p>
                                                  </div>
                                                  <div className="col-sm-3">
                                                    <small><b>Fecha de Nacimiento</b></small>
                                                    <p className="nm">{moment(curp2date(tramite.curp||'AAED000000')).format('YYYY-MM-DD')}</p>
                                                  </div>
                                              </div>




                <hr className="border border-primary border-3 opacity-75 mb-4"/>


                                              <h4 style={{marginTop: 20}}>Requisitos del Trámite</h4>


                                              {
                                                // JSON.stringify(user.rol)
                                              }

                                          <div className="row mb-3">

                                              {
                                                ["ROLE_DEPARTAMENTO","ROLE_ADMIN_MESA"].indexOf(user.rol) > -1 && (

                                                      <div className="col-sm-3">
                                                        <label htmlFor="folio" className="form-label">Folio</label>
                                                        <input type="text" className="form-control" id="folio" value={values.folio} onChange={handleChange} />
                                                      </div>
                                              
                                                )
                                              }


                                              <div className="col-sm-9">
                                                  <label htmlFor="afore" className="form-label">Afore del Retiro</label>
                                                  <Form.Select id="afore" value={values.idafore} onChange={handleChange} >
                                                  <option value={""}>Selecciona una opción</option>
                                                    {
                                                      afores.map( (afore:any,afore_indice:number) => 
                                                        <option key={afore_indice} value={afore.uuid}>{(afore.afore)}</option>
                                                      )
                                                    }
                                                  </Form.Select>
                                              </div>

                                          </div>

                                                                    
                {

                                              <div className="row mb-3">
                                                <div className="col-sm-4">

                                                      <label htmlFor="fecha_alta_anterior" className="form-label">Alta del Puesto Actual</label>
                                                      <DatePicker selected={values.fecha_alta_anterior} className="form-control" dateFormat="yyyy-MM-dd" maxDate={ new Date() } onChange={(date:Date) =>{ setFieldValue('fecha_alta_anterior', date) } }  />
                                                    
                                                </div>
                                                <div className="col-sm-4">

                                                      <label htmlFor="fecha_baja_anterior" className="form-label">Baja del Puesto Actual</label>
                                                      <DatePicker selected={values.fecha_baja_anterior} className="form-control" dateFormat="yyyy-MM-dd" maxDate={ new Date() } onChange={(date:Date) =>{ setFieldValue('fecha_baja_anterior', date) } }  />
                                                    
                                                </div>

                                                <div className="col-sm-4">
                                                        <label htmlFor="sindo" className="form-label">Fecha de SINDO</label>
                                                        <DatePicker selected={values.sindo} className="form-control" dateFormat="yyyy-MM-dd" maxDate={ new Date() } onChange={(date:Date) =>{ setFieldValue('sindo', date) } } />
                                                </div>

                                              </div>



                }

{
  // JSON.stringify(values)
}





                                          <div className="row  mb-3">

                                              <div className="col-sm-3">
                                                <label htmlFor="monto_aseguramiento" className="form-label">Monto del Retiro</label>
                                                <input type="number" className="form-control" id="monto_aseguramiento" value={values.monto_aseguramiento} onChange={handleChange} />
                                              </div>


                                              <div className="col-sm-3">
                                                <label htmlFor="semanas_cotizadas" className="form-label">Semanas Cotizadas</label>
                                                <input type="number" className="form-control" id="semanas_cotizadas" value={values.semanas_cotizadas} onChange={handleChange} />
                                              </div>

                                              <div className="col-sm-3">
                                                <label htmlFor="monto_rcv" className="form-label">Monto RCV</label>
                                                <input type="number" className="form-control" id="monto_rcv" value={values.monto_rcv} onChange={handleChange} />
                                              </div>

                                              {

                                                mesa_atencion && (

                                                        <div className="col-sm-3">
                                                          <label htmlFor="sueldo_trabajador" className="form-label">Sueldo del Trabajador</label>
                                                          <input type="number" className="form-control" id="sueldo_trabajador" value={values.sueldo_trabajador} onChange={handleChange} />
                                                        </div>

                                                )

                                              }


                                          </div>




                                              
                                          <Button type="submit">GUARDAR CAMBIOS</Button>





                                      </>
                                    
                                  




                                  </div>
                                    
                              </div>


                        </Form>

                      )}

                    </Formik>



            </div>

            
          </div>



        </Modal.Body>



      </Modal>

		</>
	)

}



export default EditarTramite